<script>
  import { activateGhosts } from "../store";
</script>

<!-- here comes ghost design -->
<div class="ghost" class:active={$activateGhosts}>
  <div class="source">
    <div class="source-result">Erste Ergebnisse ab Sonntag 18 Uhr.</div>
  </div>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 278 139.3">
    <defs>
      <style>
        .st0 {
          fill: var(--dv-ghost);
        }
      </style>
    </defs>
    <circle class="st0" cx="2.5" cy="135" r="2.3" />
    <circle class="st0" cx="9.2" cy="135" r="2.3" />
    <circle class="st0" cx="16" cy="135" r="2.3" />
    <circle class="st0" cx="22.7" cy="135" r="2.3" />
    <circle class="st0" cx="29.5" cy="135" r="2.3" />
    <circle class="st0" cx="36.2" cy="135" r="2.3" />
    <circle class="st0" cx="43" cy="135" r="2.3" />
    <circle class="st0" cx="49.7" cy="135" r="2.3" />
    <circle class="st0" cx="56.5" cy="135.1" r="2.3" />
    <circle class="st0" cx="63.3" cy="135.1" r="2.3" />
    <circle class="st0" cx="70" cy="135.1" r="2.3" />
    <circle class="st0" cx="2.8" cy="129.1" r="2.3" />
    <circle class="st0" cx="76.8" cy="135.1" r="2.3" />
    <circle class="st0" cx="9.6" cy="129" r="2.3" />
    <circle class="st0" cx="16.4" cy="129.2" r="2.3" />
    <circle class="st0" cx="23.1" cy="129.1" r="2.3" />
    <circle class="st0" cx="83.6" cy="135.1" r="2.3" />
    <circle class="st0" cx="29.9" cy="129.1" r="2.3" />
    <circle class="st0" cx="36.7" cy="129" r="2.3" />
    <circle class="st0" cx="43.5" cy="129" r="2.3" />
    <circle class="st0" cx="50.3" cy="129.2" r="2.3" />
    <circle class="st0" cx="3.5" cy="123.1" r="2.3" />
    <circle class="st0" cx="10.3" cy="123" r="2.3" />
    <circle class="st0" cx="57.1" cy="129.1" r="2.3" />
    <circle class="st0" cx="17.1" cy="123.3" r="2.3" />
    <circle class="st0" cx="23.9" cy="123.3" r="2.3" />
    <circle class="st0" cx="63.9" cy="129.1" r="2.3" />
    <circle class="st0" cx="30.7" cy="123.2" r="2.3" />
    <circle class="st0" cx="70.8" cy="129" r="2.3" />
    <circle class="st0" cx="37.6" cy="123.1" r="2.3" />
    <circle class="st0" cx="4.4" cy="117.2" r="2.3" />
    <circle class="st0" cx="11.2" cy="117.1" r="2.3" />
    <circle class="st0" cx="44.4" cy="123" r="2.3" />
    <circle class="st0" cx="77.6" cy="128.9" r="2.3" />
    <circle class="st0" cx="18" cy="117.5" r="2.3" />
    <circle class="st0" cx="51.2" cy="123.4" r="2.3" />
    <circle class="st0" cx="24.9" cy="117.4" r="2.3" />
    <circle class="st0" cx="58.1" cy="123.3" r="2.3" />
    <circle class="st0" cx="31.8" cy="117.3" r="2.3" />
    <circle class="st0" cx="5.5" cy="111.3" r="2.3" />
    <circle class="st0" cx="84.7" cy="128.2" r="2.3" />
    <circle class="st0" cx="12.5" cy="111.2" r="2.3" />
    <circle class="st0" cx="38.8" cy="117.2" r="2.3" />
    <circle class="st0" cx="65.1" cy="123.2" r="2.3" />
    <circle class="st0" cx="19.3" cy="111.8" r="2.3" />
    <circle class="st0" cx="45.8" cy="117" r="2.3" />
    <circle class="st0" cx="26.2" cy="111.7" r="2.3" />
    <circle class="st0" cx="72.1" cy="123" r="2.3" />
    <circle class="st0" cx="52.6" cy="117.7" r="2.3" />
    <circle class="st0" cx="6.9" cy="105.5" r="2.3" />
    <circle class="st0" cx="33.3" cy="111.5" r="2.3" />
    <circle class="st0" cx="14" cy="105.3" r="2.3" />
    <circle class="st0" cx="59.6" cy="117.5" r="2.3" />
    <circle class="st0" cx="20.8" cy="106.1" r="2.3" />
    <circle class="st0" cx="79.1" cy="122.9" r="2.3" />
    <circle class="st0" cx="40.3" cy="111.4" r="2.3" />
    <circle class="st0" cx="27.9" cy="106" r="2.3" />
    <circle class="st0" cx="8.6" cy="99.8" r="2.3" />
    <circle class="st0" cx="66.7" cy="117.4" r="2.3" />
    <circle class="st0" cx="47.4" cy="111.2" r="2.3" />
    <circle class="st0" cx="15.7" cy="99.6" r="2.3" />
    <circle class="st0" cx="35" cy="105.8" r="2.3" />
    <circle class="st0" cx="54.2" cy="112" r="2.3" />
    <circle class="st0" cx="22.6" cy="100.5" r="2.3" />
    <circle class="st0" cx="73.9" cy="117.2" r="2.3" />
    <circle class="st0" cx="42.2" cy="105.6" r="2.3" />
    <circle class="st0" cx="10.5" cy="94.1" r="2.3" />
    <circle class="st0" cx="86.6" cy="121.6" r="2.3" />
    <circle class="st0" cx="29.8" cy="100.4" r="2.3" />
    <circle class="st0" cx="61.4" cy="111.9" r="2.3" />
    <circle class="st0" cx="17.8" cy="93.9" r="2.3" />
    <circle class="st0" cx="49.5" cy="105.5" r="2.3" />
    <circle class="st0" cx="37" cy="100.2" r="2.3" />
    <circle class="st0" cx="24.6" cy="95" r="2.3" />
    <circle class="st0" cx="81.2" cy="117" r="2.3" />
    <circle class="st0" cx="68.7" cy="111.8" r="2.3" />
    <circle class="st0" cx="56.3" cy="106.5" r="2.3" />
    <circle class="st0" cx="12.7" cy="88.5" r="2.3" />
    <circle class="st0" cx="32" cy="94.9" r="2.3" />
    <circle class="st0" cx="44.4" cy="100" r="2.3" />
    <circle class="st0" cx="20.1" cy="88.3" r="2.3" />
    <circle class="st0" cx="63.7" cy="106.4" r="2.3" />
    <circle class="st0" cx="26.9" cy="89.6" r="2.3" />
    <circle class="st0" cx="39.4" cy="94.7" r="2.3" />
    <circle class="st0" cx="76.2" cy="111.6" r="2.3" />
    <circle class="st0" cx="15.1" cy="83" r="2.3" />
    <circle class="st0" cx="51.9" cy="99.9" r="2.3" />
    <circle class="st0" cx="34.4" cy="89.5" r="2.3" />
    <circle class="st0" cx="58.7" cy="101.2" r="2.3" />
    <circle class="st0" cx="22.6" cy="82.9" r="2.3" />
    <circle class="st0" cx="46.9" cy="94.6" r="2.3" />
    <circle class="st0" cx="71.2" cy="106.3" r="2.3" />
    <circle class="st0" cx="89.4" cy="115.2" r="2.3" />
    <circle class="st0" cx="29.5" cy="84.3" r="2.3" />
    <circle class="st0" cx="17.7" cy="77.7" r="2.3" />
    <circle class="st0" cx="42" cy="89.4" r="2.3" />
    <circle class="st0" cx="83.8" cy="111.4" r="2.3" />
    <circle class="st0" cx="66.4" cy="101.1" r="2.3" />
    <circle class="st0" cx="54.6" cy="94.4" r="2.3" />
    <circle class="st0" cx="37.2" cy="84.2" r="2.3" />
    <circle class="st0" cx="25.4" cy="77.5" r="2.3" />
    <circle class="st0" cx="79" cy="106.2" r="2.3" />
    <circle class="st0" cx="49.8" cy="89.3" r="2.3" />
    <circle class="st0" cx="61.5" cy="96" r="2.3" />
    <circle class="st0" cx="20.6" cy="72.4" r="2.3" />
    <circle class="st0" cx="32.3" cy="79.1" r="2.3" />
    <circle class="st0" cx="45" cy="84.2" r="2.3" />
    <circle class="st0" cx="74.2" cy="101" r="2.3" />
    <circle class="st0" cx="28.5" cy="72.3" r="2.3" />
    <circle class="st0" cx="40.1" cy="79.1" r="2.3" />
    <circle class="st0" cx="57.7" cy="89.2" r="2.3" />
    <circle class="st0" cx="23.7" cy="67.3" r="2.3" />
    <circle class="st0" cx="69.4" cy="96" r="2.3" />
    <circle class="st0" cx="35.3" cy="74.1" r="2.3" />
    <circle class="st0" cx="52.9" cy="84.1" r="2.3" />
    <circle class="st0" cx="87" cy="106" r="2.3" />
    <circle class="st0" cx="64.6" cy="91" r="2.3" />
    <circle class="st0" cx="48.2" cy="79.1" r="2.3" />
    <circle class="st0" cx="93" cy="109.2" r="2.3" />
    <circle class="st0" cx="31.8" cy="67.3" r="2.3" />
    <circle class="st0" cx="43.4" cy="74.2" r="2.3" />
    <circle class="st0" cx="82.2" cy="101" r="2.3" />
    <circle class="st0" cx="27" cy="62.3" r="2.3" />
    <circle class="st0" cx="38.6" cy="69.2" r="2.3" />
    <circle class="st0" cx="77.5" cy="96" r="2.3" />
    <circle class="st0" cx="61.1" cy="84.2" r="2.3" />
    <circle class="st0" cx="56.4" cy="79.2" r="2.3" />
    <circle class="st0" cx="72.8" cy="91.1" r="2.3" />
    <circle class="st0" cx="35.3" cy="62.4" r="2.3" />
    <circle class="st0" cx="51.6" cy="74.3" r="2.3" />
    <circle class="st0" cx="68" cy="86.2" r="2.3" />
    <circle class="st0" cx="30.5" cy="57.5" r="2.3" />
    <circle class="st0" cx="46.9" cy="69.4" r="2.3" />
    <circle class="st0" cx="42.2" cy="64.5" r="2.3" />
    <circle class="st0" cx="90.7" cy="101" r="2.3" />
    <circle class="st0" cx="64.8" cy="79.3" r="2.3" />
    <circle class="st0" cx="39" cy="57.7" r="2.3" />
    <circle class="st0" cx="85.9" cy="96.2" r="2.3" />
    <circle class="st0" cx="60.1" cy="74.5" r="2.3" />
    <circle class="st0" cx="34.3" cy="52.8" r="2.3" />
    <circle class="st0" cx="55.4" cy="69.6" r="2.3" />
    <circle class="st0" cx="81.2" cy="91.3" r="2.3" />
    <circle class="st0" cx="50.6" cy="64.8" r="2.3" />
    <circle class="st0" cx="76.5" cy="86.5" r="2.3" />
    <circle class="st0" cx="45.9" cy="60" r="2.3" />
    <circle class="st0" cx="71.7" cy="81.7" r="2.3" />
    <circle class="st0" cx="97.2" cy="103.7" r="2.3" />
    <circle class="st0" cx="43" cy="53.1" r="2.3" />
    <circle class="st0" cx="38.2" cy="48.3" r="2.3" />
    <circle class="st0" cx="68.9" cy="74.8" r="2.3" />
    <circle class="st0" cx="64.1" cy="70" r="2.3" />
    <circle class="st0" cx="59.4" cy="65.2" r="2.3" />
    <circle class="st0" cx="54.6" cy="60.4" r="2.3" />
    <circle class="st0" cx="49.9" cy="55.6" r="2.3" />
    <circle class="st0" cx="42.4" cy="44" r="2.3" />
    <circle class="st0" cx="47.1" cy="48.8" r="2.3" />
    <circle class="st0" cx="75.8" cy="77.4" r="2.3" />
    <circle class="st0" cx="80.5" cy="82.1" r="2.3" />
    <circle class="st0" cx="85.3" cy="86.9" r="2.3" />
    <circle class="st0" cx="90.1" cy="91.7" r="2.3" />
    <circle class="st0" cx="94.8" cy="96.4" r="2.3" />
    <circle class="st0" cx="54" cy="51.5" r="2.3" />
    <circle class="st0" cx="58.8" cy="56.2" r="2.3" />
    <circle class="st0" cx="63.6" cy="61" r="2.3" />
    <circle class="st0" cx="68.4" cy="65.7" r="2.3" />
    <circle class="st0" cx="73.2" cy="70.5" r="2.3" />
    <circle class="st0" cx="46.7" cy="39.8" r="2.3" />
    <circle class="st0" cx="51.5" cy="44.6" r="2.3" />
    <circle class="st0" cx="102.1" cy="98.8" r="2.3" />
    <circle class="st0" cx="80" cy="73.3" r="2.3" />
    <circle class="st0" cx="58.4" cy="47.5" r="2.3" />
    <circle class="st0" cx="84.9" cy="78.1" r="2.3" />
    <circle class="st0" cx="63.2" cy="52.3" r="2.3" />
    <circle class="st0" cx="89.7" cy="82.8" r="2.3" />
    <circle class="st0" cx="68" cy="57" r="2.3" />
    <circle class="st0" cx="51.2" cy="35.9" r="2.3" />
    <circle class="st0" cx="72.9" cy="61.7" r="2.3" />
    <circle class="st0" cx="94.6" cy="87.6" r="2.3" />
    <circle class="st0" cx="56.1" cy="40.6" r="2.3" />
    <circle class="st0" cx="77.7" cy="66.5" r="2.3" />
    <circle class="st0" cx="99.4" cy="92.3" r="2.3" />
    <circle class="st0" cx="62.9" cy="43.8" r="2.3" />
    <circle class="st0" cx="67.8" cy="48.5" r="2.3" />
    <circle class="st0" cx="55.9" cy="32.2" r="2.3" />
    <circle class="st0" cx="84.6" cy="69.6" r="2.3" />
    <circle class="st0" cx="72.7" cy="53.3" r="2.3" />
    <circle class="st0" cx="60.8" cy="36.9" r="2.3" />
    <circle class="st0" cx="89.5" cy="74.4" r="2.3" />
    <circle class="st0" cx="77.6" cy="58" r="2.3" />
    <circle class="st0" cx="82.5" cy="62.7" r="2.3" />
    <circle class="st0" cx="94.4" cy="79.1" r="2.3" />
    <circle class="st0" cx="67.6" cy="40.2" r="2.3" />
    <circle class="st0" cx="60.7" cy="28.6" r="2.3" />
    <circle class="st0" cx="99.4" cy="83.9" r="2.3" />
    <circle class="st0" cx="72.6" cy="45" r="2.3" />
    <circle class="st0" cx="65.7" cy="33.4" r="2.3" />
    <circle class="st0" cx="107.6" cy="94.6" r="2.3" />
    <circle class="st0" cx="77.5" cy="49.8" r="2.3" />
    <circle class="st0" cx="89.4" cy="66.2" r="2.3" />
    <circle class="st0" cx="104.4" cy="88.6" r="2.3" />
    <circle class="st0" cx="82.5" cy="54.5" r="2.3" />
    <circle class="st0" cx="72.5" cy="37" r="2.3" />
    <circle class="st0" cx="94.4" cy="71" r="2.3" />
    <circle class="st0" cx="65.7" cy="25.3" r="2.3" />
    <circle class="st0" cx="87.6" cy="59.3" r="2.3" />
    <circle class="st0" cx="77.5" cy="41.8" r="2.3" />
    <circle class="st0" cx="70.7" cy="30.1" r="2.3" />
    <circle class="st0" cx="99.4" cy="75.8" r="2.3" />
    <circle class="st0" cx="82.6" cy="46.6" r="2.3" />
    <circle class="st0" cx="77.5" cy="33.9" r="2.3" />
    <circle class="st0" cx="70.8" cy="22.2" r="2.3" />
    <circle class="st0" cx="94.4" cy="63.1" r="2.3" />
    <circle class="st0" cx="87.7" cy="51.4" r="2.3" />
    <circle class="st0" cx="104.6" cy="80.6" r="2.3" />
    <circle class="st0" cx="75.9" cy="27" r="2.3" />
    <circle class="st0" cx="82.6" cy="38.8" r="2.3" />
    <circle class="st0" cx="92.8" cy="56.2" r="2.3" />
    <circle class="st0" cx="99.5" cy="68" r="2.3" />
    <circle class="st0" cx="109.8" cy="85.4" r="2.3" />
    <circle class="st0" cx="87.8" cy="43.6" r="2.3" />
    <circle class="st0" cx="76" cy="19.3" r="2.3" />
    <circle class="st0" cx="82.7" cy="31.1" r="2.3" />
    <circle class="st0" cx="113.6" cy="91" r="2.3" />
    <circle class="st0" cx="104.7" cy="72.9" r="2.3" />
    <circle class="st0" cx="93" cy="48.5" r="2.3" />
    <circle class="st0" cx="81.3" cy="24.2" r="2.3" />
    <circle class="st0" cx="99.6" cy="60.3" r="2.3" />
    <circle class="st0" cx="87.9" cy="36" r="2.3" />
    <circle class="st0" cx="98.3" cy="53.5" r="2.3" />
    <circle class="st0" cx="81.4" cy="16.7" r="2.3" />
    <circle class="st0" cx="110" cy="77.8" r="2.3" />
    <circle class="st0" cx="93.1" cy="41" r="2.3" />
    <circle class="st0" cx="88" cy="28.5" r="2.3" />
    <circle class="st0" cx="104.8" cy="65.3" r="2.3" />
    <circle class="st0" cx="86.7" cy="21.7" r="2.3" />
    <circle class="st0" cx="98.4" cy="46" r="2.3" />
    <circle class="st0" cx="93.2" cy="33.6" r="2.3" />
    <circle class="st0" cx="86.9" cy="14.3" r="2.3" />
    <circle class="st0" cx="104.9" cy="57.9" r="2.3" />
    <circle class="st0" cx="110.1" cy="70.4" r="2.3" />
    <circle class="st0" cx="115.4" cy="82.8" r="2.3" />
    <circle class="st0" cx="93.4" cy="26.2" r="2.3" />
    <circle class="st0" cx="98.6" cy="38.6" r="2.3" />
    <circle class="st0" cx="103.8" cy="51.1" r="2.3" />
    <circle class="st0" cx="92.3" cy="19.4" r="2.3" />
    <circle class="st0" cx="110.3" cy="63.1" r="2.3" />
    <circle class="st0" cx="98.8" cy="31.4" r="2.3" />
    <circle class="st0" cx="119.9" cy="88.3" r="2.3" />
    <circle class="st0" cx="92.5" cy="12.1" r="2.3" />
    <circle class="st0" cx="104" cy="43.8" r="2.3" />
    <circle class="st0" cx="115.6" cy="75.5" r="2.3" />
    <circle class="st0" cx="98.9" cy="24.2" r="2.3" />
    <circle class="st0" cx="110.4" cy="55.9" r="2.3" />
    <circle class="st0" cx="104.2" cy="36.6" r="2.3" />
    <circle class="st0" cx="98" cy="17.4" r="2.3" />
    <circle class="st0" cx="109.6" cy="49" r="2.3" />
    <circle class="st0" cx="115.8" cy="68.3" r="2.3" />
    <circle class="st0" cx="98.2" cy="10.2" r="2.3" />
    <circle class="st0" cx="104.4" cy="29.5" r="2.3" />
    <circle class="st0" cx="109.8" cy="41.9" r="2.3" />
    <circle class="st0" cx="121.3" cy="80.7" r="2.3" />
    <circle class="st0" cx="104.5" cy="22.4" r="2.3" />
    <circle class="st0" cx="115.9" cy="61.2" r="2.3" />
    <circle class="st0" cx="103.7" cy="15.6" r="2.3" />
    <circle class="st0" cx="109.9" cy="34.9" r="2.3" />
    <circle class="st0" cx="103.9" cy="8.5" r="2.3" />
    <circle class="st0" cx="116.1" cy="54.2" r="2.3" />
    <circle class="st0" cx="121.4" cy="73.7" r="2.3" />
    <circle class="st0" cx="110.1" cy="27.8" r="2.3" />
    <circle class="st0" cx="115.4" cy="47.4" r="2.3" />
    <circle class="st0" cx="110.2" cy="20.9" r="2.3" />
    <circle class="st0" cx="121.6" cy="66.7" r="2.3" />
    <circle class="st0" cx="115.6" cy="40.4" r="2.3" />
    <circle class="st0" cx="109.6" cy="14.1" r="2.3" />
    <circle class="st0" cx="126.6" cy="86.3" r="2.3" />
    <circle class="st0" cx="109.7" cy="7.1" r="2.3" />
    <circle class="st0" cx="115.7" cy="33.4" r="2.3" />
    <circle class="st0" cx="121.7" cy="59.7" r="2.3" />
    <circle class="st0" cx="115.8" cy="26.5" r="2.3" />
    <circle class="st0" cx="121.8" cy="52.8" r="2.3" />
    <circle class="st0" cx="115.9" cy="19.6" r="2.3" />
    <circle class="st0" cx="127.3" cy="79.3" r="2.3" />
    <circle class="st0" cx="121.4" cy="46.1" r="2.3" />
    <circle class="st0" cx="115.5" cy="12.9" r="2.3" />
    <circle class="st0" cx="115.6" cy="6" r="2.3" />
    <circle class="st0" cx="121.5" cy="39.2" r="2.3" />
    <circle class="st0" cx="127.4" cy="72.4" r="2.3" />
    <circle class="st0" cx="121.6" cy="32.3" r="2.3" />
    <circle class="st0" cx="127.5" cy="65.5" r="2.3" />
    <circle class="st0" cx="121.7" cy="25.5" r="2.3" />
    <circle class="st0" cx="121.7" cy="18.7" r="2.3" />
    <circle class="st0" cx="127.5" cy="58.7" r="2.3" />
    <circle class="st0" cx="121.4" cy="11.9" r="2.3" />
    <circle class="st0" cx="121.5" cy="5.1" r="2.3" />
    <circle class="st0" cx="127.6" cy="51.9" r="2.3" />
    <circle class="st0" cx="127.4" cy="45.1" r="2.3" />
    <circle class="st0" cx="127.4" cy="38.3" r="2.3" />
    <circle class="st0" cx="127.5" cy="31.5" r="2.3" />
    <circle class="st0" cx="133.5" cy="85.2" r="2.3" />
    <circle class="st0" cx="127.5" cy="24.8" r="2.3" />
    <circle class="st0" cx="127.6" cy="18" r="2.3" />
    <circle class="st0" cx="127.4" cy="11.2" r="2.3" />
    <circle class="st0" cx="133.5" cy="78.4" r="2.3" />
    <circle class="st0" cx="127.5" cy="4.4" r="2.3" />
    <circle class="st0" cx="133.4" cy="71.6" r="2.3" />
    <circle class="st0" cx="133.4" cy="64.9" r="2.3" />
    <circle class="st0" cx="133.4" cy="58.1" r="2.3" />
    <circle class="st0" cx="133.4" cy="51.3" r="2.3" />
    <circle class="st0" cx="133.4" cy="44.6" r="2.3" />
    <circle class="st0" cx="133.4" cy="37.8" r="2.3" />
    <circle class="st0" cx="133.4" cy="31.1" r="2.3" />
    <circle class="st0" cx="133.4" cy="24.3" r="2.3" />
    <circle class="st0" cx="133.4" cy="17.6" r="2.3" />
    <circle class="st0" cx="133.4" cy="10.8" r="2.3" />
    <circle class="st0" cx="133.4" cy="4.1" r="2.3" />
    <circle class="st0" cx="144.6" cy="4.1" r="2.3" />
    <circle class="st0" cx="144.6" cy="10.8" r="2.3" />
    <circle class="st0" cx="144.6" cy="17.6" r="2.3" />
    <circle class="st0" cx="144.6" cy="24.3" r="2.3" />
    <circle class="st0" cx="144.6" cy="31.1" r="2.3" />
    <circle class="st0" cx="144.6" cy="37.8" r="2.3" />
    <circle class="st0" cx="144.6" cy="44.6" r="2.3" />
    <circle class="st0" cx="144.6" cy="51.3" r="2.3" />
    <circle class="st0" cx="144.6" cy="58.1" r="2.3" />
    <circle class="st0" cx="144.6" cy="64.9" r="2.3" />
    <circle class="st0" cx="144.6" cy="71.6" r="2.3" />
    <circle class="st0" cx="150.5" cy="4.4" r="2.3" />
    <circle class="st0" cx="144.5" cy="78.4" r="2.3" />
    <circle class="st0" cx="150.6" cy="11.2" r="2.3" />
    <circle class="st0" cx="150.4" cy="18" r="2.3" />
    <circle class="st0" cx="150.5" cy="24.8" r="2.3" />
    <circle class="st0" cx="144.5" cy="85.2" r="2.3" />
    <circle class="st0" cx="150.5" cy="31.5" r="2.3" />
    <circle class="st0" cx="150.6" cy="38.3" r="2.3" />
    <circle class="st0" cx="150.6" cy="45.1" r="2.3" />
    <circle class="st0" cx="150.4" cy="51.9" r="2.3" />
    <circle class="st0" cx="156.5" cy="5.1" r="2.3" />
    <circle class="st0" cx="156.6" cy="11.9" r="2.3" />
    <circle class="st0" cx="150.5" cy="58.7" r="2.3" />
    <circle class="st0" cx="156.3" cy="18.7" r="2.3" />
    <circle class="st0" cx="156.3" cy="25.5" r="2.3" />
    <circle class="st0" cx="150.5" cy="65.5" r="2.3" />
    <circle class="st0" cx="156.4" cy="32.3" r="2.3" />
    <circle class="st0" cx="150.6" cy="72.4" r="2.3" />
    <circle class="st0" cx="156.5" cy="39.2" r="2.3" />
    <circle class="st0" cx="162.4" cy="6" r="2.3" />
    <circle class="st0" cx="162.5" cy="12.9" r="2.3" />
    <circle class="st0" cx="156.6" cy="46.1" r="2.3" />
    <circle class="st0" cx="150.7" cy="79.3" r="2.3" />
    <circle class="st0" cx="162.1" cy="19.6" r="2.3" />
    <circle class="st0" cx="156.2" cy="52.8" r="2.3" />
    <circle class="st0" cx="162.2" cy="26.5" r="2.3" />
    <circle class="st0" cx="156.3" cy="59.7" r="2.3" />
    <circle class="st0" cx="162.3" cy="33.4" r="2.3" />
    <circle class="st0" cx="168.3" cy="7.1" r="2.3" />
    <circle class="st0" cx="151.4" cy="86.3" r="2.3" />
    <circle class="st0" cx="168.4" cy="14.1" r="2.3" />
    <circle class="st0" cx="162.4" cy="40.4" r="2.3" />
    <circle class="st0" cx="156.4" cy="66.7" r="2.3" />
    <circle class="st0" cx="167.8" cy="20.9" r="2.3" />
    <circle class="st0" cx="162.6" cy="47.4" r="2.3" />
    <circle class="st0" cx="167.9" cy="27.8" r="2.3" />
    <circle class="st0" cx="156.6" cy="73.7" r="2.3" />
    <circle class="st0" cx="161.9" cy="54.2" r="2.3" />
    <circle class="st0" cx="174.1" cy="8.5" r="2.3" />
    <circle class="st0" cx="168.1" cy="34.9" r="2.3" />
    <circle class="st0" cx="174.3" cy="15.6" r="2.3" />
    <circle class="st0" cx="162.1" cy="61.2" r="2.3" />
    <circle class="st0" cx="173.5" cy="22.4" r="2.3" />
    <circle class="st0" cx="156.7" cy="80.7" r="2.3" />
    <circle class="st0" cx="168.2" cy="41.9" r="2.3" />
    <circle class="st0" cx="173.6" cy="29.5" r="2.3" />
    <circle class="st0" cx="179.8" cy="10.2" r="2.3" />
    <circle class="st0" cx="162.2" cy="68.3" r="2.3" />
    <circle class="st0" cx="168.4" cy="49" r="2.3" />
    <circle class="st0" cx="180" cy="17.4" r="2.3" />
    <circle class="st0" cx="173.8" cy="36.6" r="2.3" />
    <circle class="st0" cx="167.6" cy="55.9" r="2.3" />
    <circle class="st0" cx="179.1" cy="24.2" r="2.3" />
    <circle class="st0" cx="162.4" cy="75.5" r="2.3" />
    <circle class="st0" cx="174" cy="43.8" r="2.3" />
    <circle class="st0" cx="185.5" cy="12.1" r="2.3" />
    <circle class="st0" cx="158.1" cy="88.3" r="2.3" />
    <circle class="st0" cx="179.2" cy="31.4" r="2.3" />
    <circle class="st0" cx="167.7" cy="63.1" r="2.3" />
    <circle class="st0" cx="185.7" cy="19.4" r="2.3" />
    <circle class="st0" cx="174.2" cy="51.1" r="2.3" />
    <circle class="st0" cx="179.4" cy="38.6" r="2.3" />
    <circle class="st0" cx="184.6" cy="26.2" r="2.3" />
    <circle class="st0" cx="162.6" cy="82.8" r="2.3" />
    <circle class="st0" cx="167.9" cy="70.4" r="2.3" />
    <circle class="st0" cx="173.1" cy="57.9" r="2.3" />
    <circle class="st0" cx="191.1" cy="14.3" r="2.3" />
    <circle class="st0" cx="184.8" cy="33.6" r="2.3" />
    <circle class="st0" cx="179.6" cy="46" r="2.3" />
    <circle class="st0" cx="191.3" cy="21.7" r="2.3" />
    <circle class="st0" cx="173.2" cy="65.3" r="2.3" />
    <circle class="st0" cx="190" cy="28.5" r="2.3" />
    <circle class="st0" cx="184.9" cy="41" r="2.3" />
    <circle class="st0" cx="168" cy="77.8" r="2.3" />
    <circle class="st0" cx="196.6" cy="16.7" r="2.3" />
    <circle class="st0" cx="179.7" cy="53.5" r="2.3" />
    <circle class="st0" cx="190.1" cy="36" r="2.3" />
    <circle class="st0" cx="178.4" cy="60.3" r="2.3" />
    <circle class="st0" cx="196.7" cy="24.2" r="2.3" />
    <circle class="st0" cx="185" cy="48.5" r="2.3" />
    <circle class="st0" cx="173.3" cy="72.9" r="2.3" />
    <circle class="st0" cx="164.4" cy="91" r="2.3" />
    <circle class="st0" cx="195.3" cy="31.1" r="2.3" />
    <circle class="st0" cx="202" cy="19.3" r="2.3" />
    <circle class="st0" cx="190.2" cy="43.6" r="2.3" />
    <circle class="st0" cx="168.2" cy="85.4" r="2.3" />
    <circle class="st0" cx="178.5" cy="68" r="2.3" />
    <circle class="st0" cx="185.2" cy="56.2" r="2.3" />
    <circle class="st0" cx="195.4" cy="38.8" r="2.3" />
    <circle class="st0" cx="202.1" cy="27" r="2.3" />
    <circle class="st0" cx="173.4" cy="80.6" r="2.3" />
    <circle class="st0" cx="190.3" cy="51.4" r="2.3" />
    <circle class="st0" cx="183.6" cy="63.1" r="2.3" />
    <circle class="st0" cx="207.2" cy="22.2" r="2.3" />
    <circle class="st0" cx="200.5" cy="33.9" r="2.3" />
    <circle class="st0" cx="195.4" cy="46.6" r="2.3" />
    <circle class="st0" cx="178.6" cy="75.8" r="2.3" />
    <circle class="st0" cx="207.3" cy="30.1" r="2.3" />
    <circle class="st0" cx="200.5" cy="41.8" r="2.3" />
    <circle class="st0" cx="190.4" cy="59.3" r="2.3" />
    <circle class="st0" cx="212.3" cy="25.3" r="2.3" />
    <circle class="st0" cx="183.6" cy="71" r="2.3" />
    <circle class="st0" cx="205.5" cy="37" r="2.3" />
    <circle class="st0" cx="195.5" cy="54.5" r="2.3" />
    <circle class="st0" cx="173.6" cy="88.6" r="2.3" />
    <circle class="st0" cx="188.6" cy="66.2" r="2.3" />
    <circle class="st0" cx="200.5" cy="49.8" r="2.3" />
    <circle class="st0" cx="170.4" cy="94.6" r="2.3" />
    <circle class="st0" cx="212.3" cy="33.4" r="2.3" />
    <circle class="st0" cx="205.4" cy="45" r="2.3" />
    <circle class="st0" cx="178.6" cy="83.9" r="2.3" />
    <circle class="st0" cx="217.3" cy="28.6" r="2.3" />
    <circle class="st0" cx="210.4" cy="40.2" r="2.3" />
    <circle class="st0" cx="183.6" cy="79.1" r="2.3" />
    <circle class="st0" cx="195.5" cy="62.7" r="2.3" />
    <circle class="st0" cx="200.4" cy="58" r="2.3" />
    <circle class="st0" cx="188.5" cy="74.4" r="2.3" />
    <circle class="st0" cx="217.2" cy="36.9" r="2.3" />
    <circle class="st0" cx="205.3" cy="53.3" r="2.3" />
    <circle class="st0" cx="193.4" cy="69.6" r="2.3" />
    <circle class="st0" cx="222.1" cy="32.2" r="2.3" />
    <circle class="st0" cx="210.2" cy="48.5" r="2.3" />
    <circle class="st0" cx="215.1" cy="43.8" r="2.3" />
    <circle class="st0" cx="178.6" cy="92.3" r="2.3" />
    <circle class="st0" cx="200.3" cy="66.5" r="2.3" />
    <circle class="st0" cx="221.9" cy="40.6" r="2.3" />
    <circle class="st0" cx="183.4" cy="87.6" r="2.3" />
    <circle class="st0" cx="205.1" cy="61.7" r="2.3" />
    <circle class="st0" cx="226.8" cy="35.9" r="2.3" />
    <circle class="st0" cx="210" cy="57" r="2.3" />
    <circle class="st0" cx="188.3" cy="82.8" r="2.3" />
    <circle class="st0" cx="214.8" cy="52.3" r="2.3" />
    <circle class="st0" cx="193.1" cy="78.1" r="2.3" />
    <circle class="st0" cx="219.6" cy="47.5" r="2.3" />
    <circle class="st0" cx="198" cy="73.3" r="2.3" />
    <circle class="st0" cx="175.9" cy="98.8" r="2.3" />
    <circle class="st0" cx="226.5" cy="44.6" r="2.3" />
    <circle class="st0" cx="231.3" cy="39.8" r="2.3" />
    <circle class="st0" cx="204.8" cy="70.5" r="2.3" />
    <circle class="st0" cx="209.6" cy="65.7" r="2.3" />
    <circle class="st0" cx="214.4" cy="61" r="2.3" />
    <circle class="st0" cx="219.2" cy="56.2" r="2.3" />
    <circle class="st0" cx="224" cy="51.5" r="2.3" />
    <circle class="st0" cx="202.2" cy="77.4" r="2.3" />
    <circle class="st0" cx="183.2" cy="96.4" r="2.3" />
    <circle class="st0" cx="235.6" cy="44" r="2.3" />
    <circle class="st0" cx="230.9" cy="48.8" r="2.3" />
    <circle class="st0" cx="197.5" cy="82.1" r="2.3" />
    <circle class="st0" cx="187.9" cy="91.7" r="2.3" />
    <circle class="st0" cx="192.7" cy="86.9" r="2.3" />
    <circle class="st0" cx="228.1" cy="55.6" r="2.3" />
    <circle class="st0" cx="223.4" cy="60.4" r="2.3" />
    <circle class="st0" cx="218.6" cy="65.2" r="2.3" />
    <circle class="st0" cx="213.9" cy="70" r="2.3" />
    <circle class="st0" cx="209.1" cy="74.8" r="2.3" />
    <circle class="st0" cx="239.8" cy="48.3" r="2.3" />
    <circle class="st0" cx="235" cy="53.1" r="2.3" />
    <circle class="st0" cx="180.8" cy="103.7" r="2.3" />
    <circle class="st0" cx="206.3" cy="81.7" r="2.3" />
    <circle class="st0" cx="232.1" cy="60" r="2.3" />
    <circle class="st0" cx="201.5" cy="86.5" r="2.3" />
    <circle class="st0" cx="227.4" cy="64.8" r="2.3" />
    <circle class="st0" cx="196.8" cy="91.3" r="2.3" />
    <circle class="st0" cx="222.6" cy="69.6" r="2.3" />
    <circle class="st0" cx="243.7" cy="52.8" r="2.3" />
    <circle class="st0" cx="217.9" cy="74.5" r="2.3" />
    <circle class="st0" cx="192.1" cy="96.2" r="2.3" />
    <circle class="st0" cx="239" cy="57.7" r="2.3" />
    <circle class="st0" cx="213.2" cy="79.3" r="2.3" />
    <circle class="st0" cx="187.3" cy="101" r="2.3" />
    <circle class="st0" cx="235.8" cy="64.5" r="2.3" />
    <circle class="st0" cx="231.1" cy="69.4" r="2.3" />
    <circle class="st0" cx="247.5" cy="57.5" r="2.3" />
    <circle class="st0" cx="210" cy="86.2" r="2.3" />
    <circle class="st0" cx="226.4" cy="74.3" r="2.3" />
    <circle class="st0" cx="242.7" cy="62.4" r="2.3" />
    <circle class="st0" cx="205.2" cy="91.1" r="2.3" />
    <circle class="st0" cx="221.6" cy="79.2" r="2.3" />
    <circle class="st0" cx="216.9" cy="84.2" r="2.3" />
    <circle class="st0" cx="200.5" cy="96" r="2.3" />
    <circle class="st0" cx="239.4" cy="69.2" r="2.3" />
    <circle class="st0" cx="251" cy="62.3" r="2.3" />
    <circle class="st0" cx="195.8" cy="101" r="2.3" />
    <circle class="st0" cx="234.6" cy="74.2" r="2.3" />
    <circle class="st0" cx="246.2" cy="67.3" r="2.3" />
    <circle class="st0" cx="185" cy="109.2" r="2.3" />
    <circle class="st0" cx="229.8" cy="79.1" r="2.3" />
    <circle class="st0" cx="213.4" cy="91" r="2.3" />
    <circle class="st0" cx="191" cy="106" r="2.3" />
    <circle class="st0" cx="225.1" cy="84.1" r="2.3" />
    <circle class="st0" cx="242.7" cy="74.1" r="2.3" />
    <circle class="st0" cx="208.6" cy="96" r="2.3" />
    <circle class="st0" cx="254.3" cy="67.3" r="2.3" />
    <circle class="st0" cx="220.3" cy="89.2" r="2.3" />
    <circle class="st0" cx="237.9" cy="79.1" r="2.3" />
    <circle class="st0" cx="249.5" cy="72.3" r="2.3" />
    <circle class="st0" cx="203.8" cy="101" r="2.3" />
    <circle class="st0" cx="233" cy="84.2" r="2.3" />
    <circle class="st0" cx="245.7" cy="79.1" r="2.3" />
    <circle class="st0" cx="257.4" cy="72.4" r="2.3" />
    <circle class="st0" cx="216.5" cy="96" r="2.3" />
    <circle class="st0" cx="228.2" cy="89.3" r="2.3" />
    <circle class="st0" cx="199" cy="106.2" r="2.3" />
    <circle class="st0" cx="252.6" cy="77.5" r="2.3" />
    <circle class="st0" cx="240.8" cy="84.2" r="2.3" />
    <circle class="st0" cx="223.4" cy="94.4" r="2.3" />
    <circle class="st0" cx="211.6" cy="101.1" r="2.3" />
    <circle class="st0" cx="194.2" cy="111.4" r="2.3" />
    <circle class="st0" cx="236" cy="89.4" r="2.3" />
    <circle class="st0" cx="260.3" cy="77.7" r="2.3" />
    <circle class="st0" cx="248.5" cy="84.3" r="2.3" />
    <circle class="st0" cx="188.6" cy="115.2" r="2.3" />
    <circle class="st0" cx="206.8" cy="106.3" r="2.3" />
    <circle class="st0" cx="231.1" cy="94.6" r="2.3" />
    <circle class="st0" cx="255.4" cy="82.9" r="2.3" />
    <circle class="st0" cx="219.3" cy="101.2" r="2.3" />
    <circle class="st0" cx="243.6" cy="89.5" r="2.3" />
    <circle class="st0" cx="226.1" cy="99.9" r="2.3" />
    <circle class="st0" cx="262.9" cy="83" r="2.3" />
    <circle class="st0" cx="201.8" cy="111.6" r="2.3" />
    <circle class="st0" cx="238.6" cy="94.7" r="2.3" />
    <circle class="st0" cx="251.1" cy="89.6" r="2.3" />
    <circle class="st0" cx="214.3" cy="106.4" r="2.3" />
    <circle class="st0" cx="257.9" cy="88.3" r="2.3" />
    <circle class="st0" cx="233.6" cy="100" r="2.3" />
    <circle class="st0" cx="246" cy="94.9" r="2.3" />
    <circle class="st0" cx="265.3" cy="88.5" r="2.3" />
    <circle class="st0" cx="221.7" cy="106.5" r="2.3" />
    <circle class="st0" cx="209.3" cy="111.8" r="2.3" />
    <circle class="st0" cx="196.8" cy="117" r="2.3" />
    <circle class="st0" cx="253.4" cy="95" r="2.3" />
    <circle class="st0" cx="241" cy="100.2" r="2.3" />
    <circle class="st0" cx="228.5" cy="105.5" r="2.3" />
    <circle class="st0" cx="260.2" cy="93.9" r="2.3" />
    <circle class="st0" cx="216.6" cy="111.9" r="2.3" />
    <circle class="st0" cx="248.2" cy="100.4" r="2.3" />
    <circle class="st0" cx="191.4" cy="121.6" r="2.3" />
    <circle class="st0" cx="267.5" cy="94.1" r="2.3" />
    <circle class="st0" cx="235.8" cy="105.6" r="2.3" />
    <circle class="st0" cx="204.1" cy="117.2" r="2.3" />
    <circle class="st0" cx="255.4" cy="100.5" r="2.3" />
    <circle class="st0" cx="223.8" cy="112" r="2.3" />
    <circle class="st0" cx="243" cy="105.8" r="2.3" />
    <circle class="st0" cx="262.3" cy="99.6" r="2.3" />
    <circle class="st0" cx="230.6" cy="111.2" r="2.3" />
    <circle class="st0" cx="211.3" cy="117.4" r="2.3" />
    <circle class="st0" cx="269.4" cy="99.8" r="2.3" />
    <circle class="st0" cx="250.1" cy="106" r="2.3" />
    <circle class="st0" cx="237.7" cy="111.4" r="2.3" />
    <circle class="st0" cx="198.9" cy="122.9" r="2.3" />
    <circle class="st0" cx="257.2" cy="106.1" r="2.3" />
    <circle class="st0" cx="218.4" cy="117.5" r="2.3" />
    <circle class="st0" cx="264" cy="105.3" r="2.3" />
    <circle class="st0" cx="244.7" cy="111.5" r="2.3" />
    <circle class="st0" cx="271.1" cy="105.5" r="2.3" />
    <circle class="st0" cx="225.4" cy="117.7" r="2.3" />
    <circle class="st0" cx="205.9" cy="123" r="2.3" />
    <circle class="st0" cx="251.8" cy="111.7" r="2.3" />
    <circle class="st0" cx="232.2" cy="117" r="2.3" />
    <circle class="st0" cx="258.7" cy="111.8" r="2.3" />
    <circle class="st0" cx="212.9" cy="123.2" r="2.3" />
    <circle class="st0" cx="239.2" cy="117.2" r="2.3" />
    <circle class="st0" cx="265.5" cy="111.2" r="2.3" />
    <circle class="st0" cx="193.3" cy="128.2" r="2.3" />
    <circle class="st0" cx="272.5" cy="111.3" r="2.3" />
    <circle class="st0" cx="246.2" cy="117.3" r="2.3" />
    <circle class="st0" cx="219.9" cy="123.3" r="2.3" />
    <circle class="st0" cx="253.1" cy="117.4" r="2.3" />
    <circle class="st0" cx="226.8" cy="123.4" r="2.3" />
    <circle class="st0" cx="260" cy="117.5" r="2.3" />
    <circle class="st0" cx="200.4" cy="128.9" r="2.3" />
    <circle class="st0" cx="233.6" cy="123" r="2.3" />
    <circle class="st0" cx="266.8" cy="117.1" r="2.3" />
    <circle class="st0" cx="273.6" cy="117.2" r="2.3" />
    <circle class="st0" cx="240.4" cy="123.1" r="2.3" />
    <circle class="st0" cx="207.2" cy="129" r="2.3" />
    <circle class="st0" cx="247.3" cy="123.2" r="2.3" />
    <circle class="st0" cx="214.1" cy="129.1" r="2.3" />
    <circle class="st0" cx="254.1" cy="123.3" r="2.3" />
    <circle class="st0" cx="260.9" cy="123.3" r="2.3" />
    <circle class="st0" cx="220.9" cy="129.1" r="2.3" />
    <circle class="st0" cx="267.7" cy="123" r="2.3" />
    <circle class="st0" cx="274.5" cy="123.1" r="2.3" />
    <circle class="st0" cx="227.7" cy="129.2" r="2.3" />
    <circle class="st0" cx="234.5" cy="129" r="2.3" />
    <circle class="st0" cx="241.3" cy="129" r="2.3" />
    <circle class="st0" cx="248.1" cy="129.1" r="2.3" />
    <circle class="st0" cx="194.4" cy="135.1" r="2.3" />
    <circle class="st0" cx="254.9" cy="129.1" r="2.3" />
    <circle class="st0" cx="261.6" cy="129.2" r="2.3" />
    <circle class="st0" cx="268.4" cy="129" r="2.3" />
    <circle class="st0" cx="201.2" cy="135.1" r="2.3" />
    <circle class="st0" cx="275.2" cy="129.1" r="2.3" />
    <circle class="st0" cx="208" cy="135.1" r="2.3" />
    <circle class="st0" cx="214.7" cy="135.1" r="2.3" />
    <circle class="st0" cx="221.5" cy="135.1" r="2.3" />
    <circle class="st0" cx="228.3" cy="135" r="2.3" />
    <circle class="st0" cx="235" cy="135" r="2.3" />
    <circle class="st0" cx="241.8" cy="135" r="2.3" />
    <circle class="st0" cx="248.5" cy="135" r="2.3" />
    <circle class="st0" cx="255.3" cy="135" r="2.3" />
    <circle class="st0" cx="262" cy="135" r="2.3" />
    <circle class="st0" cx="268.8" cy="135" r="2.3" />
    <circle class="st0" cx="275.5" cy="135" r="2.3" />
    <path fill="none" stroke="#ddd" stroke-miterlimit="1.2" stroke-width=".6" d="M139 0v89.9" />
  </svg>
</div>
